import { useMutation, useQuery } from "@tanstack/react-query";
import useAxiosInstance from "./axiosInstance.utils";
import { errorFormat } from "./handleError.utils";
import { onSuccessMessage, queryClient } from "./reactQuery.utils";
import { arrayMap } from "./array.utils";

/**
 * :::::::MUTATIONS:::::::::::
 */

export function useCreateDhakaCityThanaMutation(keyData) {
  const { postApi } = useAxiosInstance();
  async function createDhakaCityThanaApi(data) {
    try {
      const api = `/dhaka-city-thana`;
      const apiResponse = await postApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["createDhakaCityThanaApi", ...keyData],
    mutationFn: (data) => createDhakaCityThanaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-city-thanas");
      onSuccessMessage(data, 201);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, createDhakaCityThana: mutateAsync };
}

export function useUpdateDhakaCityThanaMutation(keyData) {
  const { putApi } = useAxiosInstance();
  async function updateDhakaCityThanaApi(data) {
    try {
      const api = `/dhaka-city-thana`;
      const apiResponse = await putApi(api, data);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }
  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["updateDhakaCityThanaApi", ...keyData],
    mutationFn: (data) => updateDhakaCityThanaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-city-thanas");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, updateDhakaCityThana: mutateAsync };
}

export function useDeleteDhakaCityThanaMutation(keyData) {
  const { deleteApi } = useAxiosInstance();
  async function deleteDhakaCityThanaApi(id) {
    try {
      const api = `/dhaka-city-thana/${id}`;
      const apiResponse = await deleteApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const { isPending: loading, mutateAsync } = useMutation({
    mutationKey: ["deleteDhakaCityThanaApi", ...keyData],
    mutationFn: (data) => deleteDhakaCityThanaApi(data),
    onSuccess: (data) => {
      queryClient.invalidateQueries("dhaka-city-thanas");
      onSuccessMessage(data, 200);
    },
    onError: (err) => {
      return errorFormat(err);
    }
  });

  return { loading, deleteDhakaCityThana: mutateAsync };
}

/**
 * :::::::QUERIES:::::::::::
 */
export function useGetAllDhakaCityThanaQuery({ query, options = {}, key = "" }) {
  const { getApi } = useAxiosInstance();
  async function getAllDhakaCityThanaApi(query) {
    try {
      const api = `/dhaka-city-thanas${query ?? ""}`;
      const apiResponse = await getApi(api);
      return apiResponse;
    } catch (error) {
      return errorFormat(error);
    }
  }

  const {
    data,
    isPending: loading,
    ...rest
  } = useQuery({
    queryKey: [`getAllDhakaCityThana-${query ?? ""}${key ? "-" + key : ""}`],
    queryFn: () => getAllDhakaCityThanaApi(query),
    ...options
  });
  const newData = data?.data?.data ?? {};
  const parents = data?.data?.parents ?? [];
  return { data: newData, parents, loading, ...rest };
}

export function dhakaCityMakeNameWithPostCode(data) {
  const name_post_code = `${data?.name ?? ""} ${data?.post_code ? `- ${data?.post_code}` : ""}`;
  return {
    name_post_code,
    ...data
  };
}

export function dhakaCityParseNamePostCode(data) {
  return arrayMap(data, (item) => dhakaCityMakeNameWithPostCode(item)) || [];
}
